<template>
  <span class="ap-input-number">
    <input type="text" :value="value" 
      @input="input($event)"
      @keydown.up.prevent="add"
      @keydown.down.prevent="redius" number>
    <a class="btn-up" @mousedown="add">
      <i class="fas fa-chevron-up"></i>
    </a>
    <a class="btn-down" @mousedown="redius">
      <i class="fas fa-chevron-down"></i>
    </a>
  </span>
</template>
<script>
  export default {
    /*model: {
      prop: 'value',
      event: 'input'
    },*/
    props: {
      value: Number,
      min: {
        type: Number,
        default: -Infinity
      },
      max: {
        type: Number,
        default: Infinity
      },
      scope: Object
    },
    data() {
      return {
        // val: this.value
      }
    },
    computed: {
      val() {
        return this.value;
      }
    },
    methods: {
      add() {
        let v = parseInt(this.val, 10);
        if(!isNaN(v) && v < this.max) {
          // this.val = v + 1;
          var _v = v + 1;
          this.$emit('update:value', _v);
          this.$emit('change', _v, this.scope);
        }
      },
      redius() {
        let v = parseInt(this.val, 10);
        if(!isNaN(v) && v > this.min) {
          // this.val = v - 1;
          var _v = v - 1;
          this.$emit('update:value', _v);
          this.$emit('change', _v, this.scope);
        }
      },
      input(evt) {
        let v = parseInt(evt.target.value, 10);
        if(!isNaN(v)) {
          this.$emit('update:value', v);
          this.$emit('change', v, this.scope);
        }
      }
    }
  }
</script>
<style lang="less">
  @import url('../assets/less/vars.less');

  .ap-input-number {
    display: inline-block;
    position: relative;
    border: 1px solid #ccc;

    a {
      position: absolute;
      right: 0;
      width: 22rem/@fontsize;
      height: 50%;
      text-align: center;
      line-height: 1.4;

      &:hover {
        background: #f2f2f2;
      }
    }
    input {
      display: block;
      padding: 7px 22rem/@fontsize 7px 7px;
      width: 80rem/@fontsize;
      border: none;
      text-align: center;
      font-weight: bold;
      color: #f00;
      font-size: 14rem/@fontsize;
      line-height: 1.5;
    }
    .btn-up {
      top: 0;
      border-left: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
    }
    .btn-down {
      top: 50%;
      border-left: 1px solid #ccc;
    }
  }
</style>